import {BehaviorSubject, Subscription} from 'rxjs';
import {UserInfoQuery} from '../../common/elf-store/user-info/user-info.query';
import {UserInfoState, UserStatus} from '../../common/elf-store/user-info/user-info.type';

interface UserSession {
  mcOnLogout?: () => void;
  mcOnLogin?: (info: UserInfoState) => void;
}

export abstract class MCActionsService implements UserSession {
  /**
   * Callback in subscribe for userInfo is not guaranteed to be called asynchronously.
   * That means that methods mcOnLogout, mcOnLogin in child classes of MCActionsService can be called
   * before its initialization. To avoid that we use initialized flag in child class constructor:
   * this.initialized$.next(true);
   */
  public userInfo: UserInfoState;
  protected readonly initialized$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private readonly userInfoSubscription: Subscription;
  private readonly isInitialized: boolean = false;

  constructor(public userInfoQuery: UserInfoQuery) {
    this.userInfoSubscription = this.userInfoQuery.userInfo$.subscribe((userInfo: UserInfoState) => {
      this.userInfo = userInfo;
      const {userStatus} = userInfo;

      if (userStatus === null) {
        return;
      }

      if (!this.initialized$.value) {
        // Run user session methods only after child class will be initialized
        const initSubscription = this.initialized$.asObservable().subscribe(value => {
          if (!value) {
            return;
          }

          initSubscription.unsubscribe();

          this.onUserSessionChange(userInfo);
        });
        return;
      }

      this.onUserSessionChange(userInfo);
    });
  }

  mcOnLogout?(): void;

  mcOnLogin?(userInfo: UserInfoState): void;

  private onUserSessionChange(userInfo: UserInfoState) {
    if (userInfo.userStatus === UserStatus.LoggedOut && this.mcOnLogout) {
      this.mcOnLogout();
      return;
    }

    if (userInfo.userStatus === UserStatus.LoggedIn && this.mcOnLogin) {
      this.mcOnLogin(userInfo);
      return;
    }
  }
}
